import { useRef } from 'react';
import styles from './InboxPage.module.css';
import { fetchApi, makeResetCache, notifyError, notifyResponse } from 'gossamer-front-end';
import { CompoundResponse } from 'gossamer-unified';
import { AllAddMessageRequest } from 'cb-model';
import { useDispatch } from 'react-redux';

interface NewMessageProps {
  convoId: number;
}

export const NewMessage = (props: NewMessageProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  const checkForEnterKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      send();
    }
  };

  const send = async () => {
    if (!inputRef.current.value) {
      return;
    }
    try {
      const payload: AllAddMessageRequest = {
        convoId: props.convoId,
        message: inputRef.current.value,
      };
      const resp: CompoundResponse = await fetchApi('POST', '/main/add-convo-message', payload);
      // reset cache
      const resetCache = makeResetCache(dispatch);
      notifyResponse(resp, 'sent successfully');
      resetCache('ConvoUserView');
      resetCache('ConvoMessage');
      inputRef.current.value = '';
    } catch (error) {
      notifyError(error, 'An error occurred while sending the message');
    }
  };
  return (
    <div className={styles.NewMessage}>
      <input type="text" name="new-message" ref={inputRef} onKeyUp={checkForEnterKey} placeholder="Type a message..." />
      <span onClick={send}>➤</span>
    </div>
  );
};
